import i18n from "i18next";

import classes from "./PromotionSection.module.scss";
import USE_CASE_DESKTOP from "../../../assets/img/MrFamily_UseCase_Desktop.png";
import USE_CASE_MOBILE from "../../../assets/img/MrFamily_UseCase_Mobile.png";
import BLOB_BG from "../../../assets/img/MrFamily_Blob.svg";
import RECPOD_LOGO from "../../../assets/img/MrFamily_RecPod_Logo.svg";
import RECPOD_THUMBNAIL from "../../../assets/img/MrFamily_RecPod_Thumbnail.png";
import STEP_NOTCH_WHITE from "../../../assets/img/MrFamily_Step_Notch_White.svg";
import STEP_ARROW_TO2 from "../../../assets/img/MrFamily_Step_Arrow_To2.svg";
import STEP_ARROW_TO3 from "../../../assets/img/MrFamily_Step_Arrow_To3.svg";
import STEP_ATTENTION_CIRCLE from "../../../assets/img/MrFamily_Step_Attention.svg";
import WARNING_TRIANGLE from "../../../assets/img/MrFamily_Warning_Triangle.svg";

const PromotionSection: React.FC = () => {
  return (
    <div className={classes["promotion"]}>
      <section className={classes["product"]}>
        <div className={classes["product-watermark"]} aria-hidden="true">
          FREE TRIAL
        </div>
        <div className={classes["hero"]}>
          <div className={classes["hero-heading"]}>
            <div className={classes["hero-badge"]}>
              <span className={classes["hero-badge-prefix"]}>
                {i18n.t("register_form_mr_family.promo.hero.badge_prefix") as string}
              </span>
              <span className={classes["hero-badge-pill"]}>
                {i18n.t("register_form_mr_family.promo.hero.badge_highlight") as string}
              </span>
              <span>
                {i18n.t("register_form_mr_family.promo.hero.badge_suffix") as string}
              </span>
            </div>
            <h2 className={classes["hero-catch"]}>
              <span>
                {i18n.t("register_form_mr_family.promo.hero.catch_line1") as string}
              </span>
              <span>
                {i18n.t("register_form_mr_family.promo.hero.catch_line2") as string}
              </span>
            </h2>
          </div>
          <p className={classes["hero-sub"]}>
            <span>
              {i18n.t("register_form_mr_family.promo.hero.sub_line1") as string}
            </span>
            <span>
              {i18n.t("register_form_mr_family.promo.hero.sub_line2") as string}
            </span>
            <span>
              {i18n.t("register_form_mr_family.promo.hero.sub_line3") as string}
            </span>
          </p>
        </div>
        <div className={classes["usecase"]}>
          <img src={BLOB_BG} alt="" className={classes["usecase-blob"]} />
          <div className={classes["usecase-scene"]}>
            <h3 className={classes["usecase-title"]}>
              {i18n.t("register_form_mr_family.promo.usecase.title") as string}
            </h3>
            <p className={classes["usecase-sub"]}>
              {i18n.t("register_form_mr_family.promo.usecase.sub") as string}
            </p>
            <picture>
              <source media="(max-width: 768px)" srcSet={USE_CASE_MOBILE} />
              <img
                src={USE_CASE_DESKTOP}
                alt={i18n.t("register_form_mr_family.promo.usecase.image_alt") as string}
                className={classes["usecase-img"]}
              />
            </picture>
          </div>
          <div className={classes["recpod-card"]}>
            <img
              src={RECPOD_THUMBNAIL}
              alt={i18n.t("register_form_mr_family.promo.recpod.thumbnail_alt") as string}
              className={classes["recpod-thumbnail"]}
            />
            <div className={classes["recpod-body"]}>
              <img
                src={RECPOD_LOGO}
                alt={i18n.t("register_form_mr_family.promo.recpod.logo_alt") as string}
                className={classes["recpod-logo"]}
              />
              <p className={classes["recpod-description"]}>
                {i18n.t("register_form_mr_family.promo.recpod.description") as string}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className={classes["howto"]}>
        <h3 className={classes["howto-header"]}>
          <span className={classes["howto-header-text"]}>
            {i18n.t("register_form_mr_family.promo.steps.title_prefix") as string}
          </span>
          <span className={classes["howto-header-number"]}>
            {i18n.t("register_form_mr_family.promo.steps.title_number") as string}
          </span>
          <span className={classes["howto-header-text"]}>
            {i18n.t("register_form_mr_family.promo.steps.title_suffix") as string}
          </span>
        </h3>
        <div className={classes["howto-content"]}>
          <ol className={classes["steps"]}>
            <li className={`${classes["step"]} ${classes["step1"]}`}>
              <div className={classes["step-attention"]}>
                <img
                  src={STEP_ATTENTION_CIRCLE}
                  alt=""
                  className={classes["step-attention-circle"]}
                />
                <span className={classes["step-attention-text"]}>
                  <span>
                    <span className={classes["step-attention-large"]}>
                      {i18n.t("register_form_mr_family.promo.steps.attention_line1_large") as string}
                    </span>
                    <span className={classes["step-attention-small"]}>
                      {i18n.t("register_form_mr_family.promo.steps.attention_line1_small") as string}
                    </span>
                  </span>
                  <span className={classes["step-attention-large"]}>
                    {i18n.t("register_form_mr_family.promo.steps.attention_line2") as string}
                  </span>
                </span>
              </div>
              <p>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step1_line1") as string}
                </span>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step1_line2") as string}
                </span>
              </p>
              <img src={STEP_ARROW_TO2} alt="" className={classes["step-arrow"]} />
            </li>
            <li className={`${classes["step"]} ${classes["step2"]}`}>
              <img src={STEP_NOTCH_WHITE} alt="" className={classes["step-notch"]} />
              <p>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step2_line1") as string}
                </span>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step2_line2") as string}
                </span>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step2_line3") as string}
                </span>
              </p>
              <img src={STEP_ARROW_TO3} alt="" className={classes["step-arrow"]} />
            </li>
            <li className={`${classes["step"]} ${classes["step3"]}`}>
              <img src={STEP_NOTCH_WHITE} alt="" className={classes["step-notch"]} />
              <p>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step3_line1") as string}
                </span>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step3_line2") as string}
                </span>
                <span>
                  {i18n.t("register_form_mr_family.promo.steps.step3_line3") as string}
                </span>
              </p>
            </li>
          </ol>
          <p className={classes["howto-note"]}>
            <img src={WARNING_TRIANGLE} alt="" className={classes["howto-note-icon"]} />
            <span>
              {i18n.t("register_form_mr_family.promo.steps.note_prefix") as string}
              <strong>
                {i18n.t("register_form_mr_family.promo.steps.note_bold") as string}
              </strong>
              {i18n.t("register_form_mr_family.promo.steps.note_suffix") as string}
            </span>
          </p>
        </div>
      </section>
    </div>
  );
};

export default PromotionSection;
